// shared animations for all Hero components (transition images, UI components)
import gsap from "gsap";
export const animateTransitionImages = (
  heroTL: gsap.core.Timeline,
  imageContainers: NodeListOf<Element>
): void => {
  const hasImages = imageContainers.length > 0;

  if (!hasImages) return;

  gsap.set(imageContainers, { yPercent: -100 });
  heroTL.from(imageContainers, {
    y: "100vh",
    yPercent: 120,
    duration: 1.6,
    ease: "none",
    stagger: { amount: 0.5, from: "random" },
  });
};

export const showUIAndRestOfPage = (heroTL: gsap.core.Timeline): void => {
  // label "showUI" should be present in the provided Timeline

  heroTL.fromTo(
    ".navigation__main_menu_label",
    {
      y: 0,
      autoAlpha: 0,
      yPercent: 100,
      duration: 0.6,
    },
    {
      autoAlpha: 1,
      yPercent: 0,
    },
    "showUI"
  );
  heroTL.fromTo(
    ".navigation__side_menu_item",
    {
      autoAlpha: 0,
      scale: 0,
      duration: 0.6,
      stagger: 0.05,
      ease: "back.out(2)",
    },
    {
      autoAlpha: 1,
      scale: 1,
    },
    "showUI"
  );

  if (document.querySelector(".latest_news__toggle") !== null) {
    heroTL.fromTo(
      ".latest_news__toggle",
      {
        autoAlpha: 0,
        duration: 0.6,
      },
      { autoAlpha: 1 },
      "showUI+=0.6"
    );
  }

  if (document.querySelector(".hero__scroll_indicator")) {
    gsap.set(".hero__scroll_indicator .arrow", { autoAlpha: 0 });
    heroTL.from(".hero__scroll_indicator ", { autoAlpha: 0 }, "showUI");
    heroTL.add(() => {
      gsap.to(".hero__scroll_indicator .arrow", { autoAlpha: 1 });
      gsap.to(".hero__scroll_indicator .arrow", {
        yPercent: 100,
        duration: 1,
        ease: "none",
        repeat: -1,
        yoyo: true,
      });
    }, "showUI");
  }

  heroTL.add(() => {
    document.body.classList.remove("lockScroll");

    const doNotScrollElements = [
      ...document.querySelectorAll<HTMLElement>(
        "section:not([data-reveal-on-scroll])"
      ),
    ];

    /* TOGGLE VISIBILITY FOR ALL ROOT PAGE ELEMENTS WITHOUT SCROLL TRANSITIONS */
    gsap.set(
      ".pagecontainer >section:not([data-reveal-on-scroll]), .pagecontainer > .backgroundwrapper, .pagecontainer>footer",
      {
        autoAlpha: 1,
      }
    );

    /* REVEAL SECTIONS */
    const revealElements = [
      ...document.querySelectorAll<HTMLElement>("[data-reveal-on-scroll]"),
    ];

    revealElements.forEach((element) => {
      const { revealOnScrollDelay } = element.dataset;

      const startPercentage = "100%";

      gsap.set(element, { y: 100, autoAlpha: 0 });
      gsap.timeline({
        scrollTrigger: {
          trigger: element,
          start: `top ${startPercentage}`,
          onEnter: () => {
            gsap.to(element, {
              y: 0,
              autoAlpha: 1,
              duration: 0.8,
              ease: "power2.out",
              delay:
                revealOnScrollDelay !== undefined ? revealOnScrollDelay : 0,
            });
          },
          once: true,
        },
      });
    });
  }, "showUI");
};
